<div class="admin-tlr-container">
    <h2>Anomaly Report Details</h2>
  
    <p-table [value]="users" styleClass="p-datatable-sm" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header">
        <tr>
          <th>Division</th>
          <th>Section</th>
          <th>Plant</th>
          <th>Tag Number</th>
          <th>Anomaly</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr>
          <td>{{ user.division }}</td>
          <td>{{ user.section }}</td>
          <td>{{ user.plant }}</td>
          <td>{{ user.tagNumber }}</td>
          <td>{{ user.anomaly }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  